module.exports = __webpack_public_path__ + "img/logo-gcyc.b75a2866.svg";